import { useEffect, useRef } from 'react';

export function useThrottle(fn: (...args: any) => any, wait: number) {
  const isCalledRef = useRef(false);
  const timeoutRef = useRef<unknown | undefined>(undefined);
  useEffect(() => {
    return () => {
      if (timeoutRef.current !== undefined) {
        clearTimeout(timeoutRef.current as number);
      }
    };
  }, [timeoutRef]);
  return (...args: any) => {
    if (!isCalledRef.current) {
      fn.apply(args);
      isCalledRef.current = true;
      timeoutRef.current = setTimeout(() => {
        isCalledRef.current = false;
      }, wait);
    }
  };
}
